document.addEventListener("DOMContentLoaded", (event) => {
    let header = null;
    if (document.querySelector('#headerBorderWrap')) {
        header = document.querySelector('#headerBorderWrap');
    }

    if (header) {
        let navigation_links = header.querySelectorAll('.js-navigation-link');

        if (navigation_links.length > 0) {
            // Open the first navigation link by default
            let firstLink = navigation_links[0];
            let firstHandleId = firstLink.getAttribute('data-handle-id');
            if (firstHandleId) {
                document.querySelector(`#${firstHandleId}`).style.maxHeight = '450px';
                document.querySelector(`#${firstHandleId}`).style.opacity = '1';
                firstLink.classList.add('active');
            }

            navigation_links.forEach((link) => {
                let hoverTimeout;
                link.addEventListener('mouseover', () => {
                    hoverTimeout = setTimeout(() => {
                        // Hide all block-collections first
                        document.querySelectorAll('.block-collection').forEach((el) => {
                            el.style.maxHeight = '0';
                            el.style.opacity = '0';
                        });

                        // Show only the relevant one
                        let handle_id = link.getAttribute('data-handle-id');
                        let target = document.querySelector(`#${handle_id}`);
                        if (target) {
                            target.style.maxHeight = '450px';
                            target.style.opacity = '1';
                        }
                        link.classList.add('active');
                    }, 250);
                });

                link.addEventListener('mouseout', () => {
                    clearTimeout(hoverTimeout);
                    // Optionally, hide all again or keep the last one open
                });

                navigation_links.forEach((other_link) => {
                    let hoverOtherTimeout;
                    other_link.addEventListener('mouseover', () => {
                        if (other_link !== link) {
                            hoverOtherTimeout = setTimeout(() => {
                                clearTimeout(hoverTimeout);
                                let handle_id = link.getAttribute('data-handle-id');
                                document.querySelector(`#${handle_id}`).style.maxHeight = '0';
                                document.querySelector(`#${handle_id}`).style.opacity = '0';
                                link.classList.remove('active');
                            }, 180);
                        }
                    });

                    other_link.addEventListener('mouseout', () => {
                        clearTimeout(hoverOtherTimeout);
                    });
                });
            });
        }
    }
});
